import { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
import { classNames } from '../../utils/classNames';
import FormField from './FormField';

const Select = forwardRef(function Select(
  { id, label, hint, error, required, options = [], placeholder, className, ...props },
  ref
) {
  return (
    <FormField id={id} label={label} hint={hint} error={error} required={required} className={className}>
      <div className="relative">
        <select
          ref={ref}
          id={id}
          required={required}
          aria-invalid={Boolean(error)}
          aria-describedby={hint || error ? `${id}-description` : undefined}
          className={classNames('h-10 w-full appearance-none rounded-control border bg-white px-3 pr-9 text-sm text-content-primary shadow-xs outline-none transition focus:border-primary-500 focus:shadow-focus disabled:bg-slate-100', error && 'border-danger-500')}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-content-muted" aria-hidden="true" />
      </div>
    </FormField>
  );
});

export default Select;
